<template>
    <div class="text-center">
        <div v-if="useImage">
            <div class="px-2xl md:px-0 flex justify-center items-center" style="min-height: 85px;">
                <img
                    :src="tvPackage.image"
                    :alt="tvPackage.name"
                    style="width: 124px;"
                >
            </div>
            <div v-if="tvPackage.monthly_price" class="mt-xs text-sm font-semibold">
                {{ format_sek_per_month(tvPackage.monthly_price) }}
            </div>
        </div>
        <div v-else>
            <div class="font-semibold text-xs text-neutral-dark" style="min-height: 38px;">
                {{ tvPackage.name }}
            </div>
            <div v-if="tvPackage.monthly_price >= 0" class="mt-sm text-lg font-bold">
                {{ format_sek_per_month(tvPackage.monthly_price) }}
            </div>
            <h5
                v-if="tvPackage.hd_channels"
                class="text-xs text-neutral-dark mt-md"
            >
                {{ tvChannels }} {{ lang('TV-kanaler','TV Channels') }}
            </h5>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            useImage: {
                type: Boolean,
                default: false,
            },
            tvPackage: {
                type: Object,
                required: true,
            },
        },
        computed: {
            tvChannels() {
                let channels = 0;

                if (this.tvPackage.hd_channels) {
                    channels += this.tvPackage.hd_channels.length;
                }

                if (this.tvPackage.sd_channels) {
                    channels += this.tvPackage.sd_channels.length;
                }

                return channels;
            },
        },
    };
</script>
